module.exports = __webpack_public_path__ + "static/media/move.b3265ed3.png";